import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Drawer, Button, Space } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faCloudDownload, faRefresh } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../../DashBaord/Top_navbar";
import ShowData from "../../../../components/ShowData";
import { Link } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import { voucherList } from "../../../../controllers/V1/promocodes/promocodeController";
import { getPage } from "../../../../controllers/common";
import ExportPopup from './Export';
import { formatProjectDate } from "../../../../controllers/common";
import { usePermissions } from "../../../../controllers/PermissionContext";
import { list as generalData } from "../../../../controllers/V1/cms/generalDataController";
import { statusMessage } from "../../../../controllers/common";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("promoCodesVoucher");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [fromDate, setFromDate] = useState(`${moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [toDate, setToDate] = useState(`${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`);

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'order_no' && {order_no : { $regex: filter?.search, $options: "i" } }),

          ...(filter?.filter_by === 'buyer_first_name' && {buyer_first_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'buyer_last_name' && {buyer_last_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'buyer_mobile' && {buyer_mobile : { $regex: filter?.search, $options: "i" } }),

          ...(filter?.filter_by === 'seller_first_name' && {seller_first_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'seller_last_name' && {seller_last_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'seller_mobile' && {seller_mobile : { $regex: filter?.search, $options: "i" } }),

          ...(filter?.filter_by === 'voucher_number' && {voucher_number : parseInt(filter?.search) }),
          ...(filter?.filter_by === 'points'?{points : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'redeem_order_no'?{redeem_order_no : filter?.search }:null),
          ...(filter?.from?{createdAt : {$gte : filter.from, $lte : filter.to} }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await voucherList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalDataCount(listData?.count);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      setFromDate("");
      setToDate("");
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      const to = moment(form.get('to_date')).format('YYYY-MM-DD HH:mm:ss')
      const from = moment(form.get('from_date')).format('YYYY-MM-DD HH:mm:ss')
      setFilter((pre) => ({
        ...pre,
        filter_by: form.get("filter_by") || "",
        search: form.get("search") || "",
        'to'        : form.get('to_date') ? moment(to).format('YYYY-MM-DD HH:mm:ss') : '',
        'from'      : form.get('from_date') ? moment(from).format('YYYY-MM-DD HH:mm:ss') : ''
      }));
      
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  const getGeneralData = async () => {
    try {
      const res = await generalData();
      if(res?.status === true){
        const { draw_start_time, draw_end_time } = res.result;
        if(draw_start_time) setFromDate(`${moment().format('YYYY-MM-DD')} ${draw_start_time}`)
        if(draw_end_time) setToDate(`${moment().format('YYYY-MM-DD')} ${draw_end_time}`)
      }  
    } catch (error) {
      
    }
  }
  useEffect(()=>{
    getGeneralData();
  },[])

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Crown King || Voucher's list";
  }, [currentPage, showRequest, filter, LIMIT]);

  const handleChnageTab = (status='') => {
    handlePageChange('',1)
    setShowRequest(status);
  }

  const handleFilterChange = (e) =>{
    const {name, value} = e.target;
    if(name === 'filter_by' && value === 'order_no'){
      setFilter((pre)=>({
        ...pre,
        [name] : value,
        search : 'CKP'
      }))
    } else if(name === 'filter_by' && value !== 'order_no'){
      setFilter((pre)=>({
        ...pre,
        [name] : value,
        search : ''
      }))
    } else if(name === 'from_date'){
      setFromDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else if(name === 'to_date'){
      setToDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else {
      setFilter((pre)=>({
        ...pre,
        [name] : value
      }))
    }
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Promo Code's Vouchers"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleChnageTab("")}
                    />
                    <Tab
                      label="Active"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleChnageTab("A")}
                    />
                    <Tab
                      label="Redeemed"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleChnageTab("Redeem")}
                    />
                    <Tab
                    label="Cancelled"
                    className="tabs_main_contnet"
                    {...a11yProps(0)}
                    onClick={() => setShowRequest("Cancel")}
                  />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT}/>
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.export === 'Y') && (
                    <div className="inventory_filter_div" onClick={handleExportDrawer}>
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        Export
                      </Link>
                    </div>
                  )}
                  <div className="inventory_filter_div"> 
                    <Link to={false} onClick={()=>getList()}><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Order No.</th>
                              <th>Buyer's Details</th>
                              <th>Seller's Details</th>
                              <th>Voucher's Number</th>
                              <th>Points</th>
                              <th>Expiry Date</th>
                              <th>Created Date & Time</th>
                              <th>Redeem Details</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                <tr key={index} >
                                    <td>{SKIP + index + 1}</td>
                                    <td>{items?.order_no}</td>
                                    <td>
                                        Name : {`${items?.buyer_first_name} ${items?.buyer_last_name}`} <br/>
                                        Ph. : {items.buyer_mobile}
                                    </td>
                                    <td>
                                        Name : {items?.seller_first_name} {items?.seller_last_name} <br/>
                                        Ph. : {items?.seller_mobile} <br/>
                                        POS No. : {items?.seller_pos_number}
                                    </td>
                                    <td className="admin_user_list_date">{items?.voucher_number}</td>
                                    <td className="admin_user_list_date">{items?.points}</td>
                                    <td className="admin_user_list_date">{moment(formatProjectDate(items?.expiry_date)).format('DD-MM-YYYY')}</td>
                                    <td className="admin_user_list_date">{moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY hh:mm A')}</td>
                                    {(items?.redeemed_date && items?.redeemed_date)?(
                                      <td className="admin_user_list_date">
                                        <p>Order No. : {items?.redeem_order_no}</p>
                                        <p>{moment(formatProjectDate(items?.redeemed_date)).format('DD-MM-YYYY hh:mm A')}</p>
                                      </td>
                                    ):(
                                      <td>-</td>
                                    )}
                                    <td className="admin_user_list_date" dangerouslySetInnerHTML={{__html: statusMessage(items?.status)}}></td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                                <td colspan="8" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                        <p>{`${SKIP + 1} - ${LIMIT * currentPage} of ${totalDataCount}`}</p>
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'var(--brand-red)', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='order_no' selected={filter?.filter_by ==='order_no'?true:false}>Order No</option>

                  <option value='buyer_first_name' selected={filter?.filter_by ==='buyer_first_name'?true:false}>Buyer's First Name</option>
                  <option value='buyer_last_name' selected={filter?.filter_by ==='buyer_last_name'?true:false}>Buyer's Last Name</option>
                  <option value='buyer_mobile' selected={filter?.filter_by ==='buyer_mobile'?true:false}>Buyer's Mobile</option>

                  <option value='seller_first_name' selected={filter?.filter_by ==='seller_first_name'?true:false}>Seller's First Name</option>
                  <option value='seller_last_name' selected={filter?.filter_by ==='seller_last_name'?true:false}>Seller's Last Name</option>
                  <option value='seller_mobile' selected={filter?.filter_by ==='seller_mobile'?true:false}>Seller's Mobile</option>

                  <option value='voucher_number' selected={filter?.filter_by ==='voucher_number'?true:false}>Voucher Number</option>
                  <option value='points' selected={filter?.filter_by ==='points'?true:false}>Points</option>
                  <option value='redeem_order_no' selected={filter?.filter_by ==='redeem_order_no'?true:false}>Redeem Order No.</option>

                  <option value='status' selected={filter?.filter_by ==='status'?true:false}>Status</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="from_date"
                  value={fromDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="to_date"
                  value={toDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "var(--brand-red-dark)", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
